import MuiChip from './MuiChip';
export default MuiChip;
